<template>
    <div>
        <FullCalendar
            ref="fullCalendar"
            defaultView="timeGridDay"
            :plugins="calendarPlugins"
            :options="calendarOptions"

            />


    </div>






</template>








<script>

import '@fullcalendar/core/vdom'
import FullCalendar, { CalendarOptions, EventApi, DateSelectArg, EventClickArg } from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import esLocale from '@fullcalendar/core/locales/es'
import listPlugin from '@fullCalendar/list'
import {mapGetters} from 'vuex'
import { throwStatement } from '@babel/types'



    export default {
        name: 'Calendar',


        components: {
            FullCalendar,
        },


        data() {
            return {
            eventGuid : 0,
            id:0,


           calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
            ],
            calendarWeekends: false,
          // opciones del calendario

          calendarOptions: {
               plugins: [dayGridPlugin,timeGridPlugin,interactionPlugin],
               initialView: 'timeGridWeek',
               locale: esLocale,
               headerToolbar: {
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                editable: true,
                selectable: true,
                selectMirror: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                events:this.eventsList,
                eventDrop:this.handleEventDrop

           },

           

        };
    },


    methods: {

        handleEventDrop: function(e){


            axios.put("/calendar/appointments/edit/"+e.event.id, {
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          start: e.event.startStr,
          end: e.event.endStr
        }) .then
               (this.eventsList
               )

            .catch(function (error) {
                     console.log('uppps 3')
                 }

               )

        },










    eventsList: function() {

            axios.get("/calendar/appointments/listado")
            .then(response => {
                this.calendarOptions.events=response.data.events
            })
            .catch(function (error) {
                     console.log('uppps 1')
                 })

            },

    handleDateSelect(selectInfo){
      let title = prompt('Introduzca Evento')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

    //  console.log('añadir')
    //  console.log(selectInfo.startStr)
    //  console.log(selectInfo.start)
      if (title) {
          axios.post("/calendar/appointments/new", {
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            title: title,
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            dia_completo: selectInfo.allDay,
            all_day: selectInfo.allDay,
         })
            .then( response=>{

                calendarApi.addEvent({
                                id:   response.data.id,
                                title: response.data.title,
                                start: response.data.start,
                                end: response.data.end,
                                allDay: response.data.all_day
                                })
                            })

         .catch(function (error) {
                     console.log('uppps')
                 })
    }

    },



    handleEventClick(clickInfo) {

      if (confirm(`Confirme que desea Eliminar '${clickInfo.event.title}'`)) {
          // console.log(clickInfo.event.id)

            axios.delete("/calendar/appointments/"+clickInfo.event.id)
                    .then(response => {
                        clickInfo.event.remove()
                 });

      }
    },







  },

};




    </script>

    <style>
        .fc-content {
            color: white;
        }
 .fc-day-sun,.fc-day-sat {
    background-color: #ff6478;
}
    </style>
